import { render, staticRenderFns } from "./DialogStatusNickname.vue?vue&type=template&id=aa90c358&scoped=true"
import script from "./DialogStatusNickname.js?vue&type=script&lang=js&external"
export * from "./DialogStatusNickname.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa90c358",
  null
  
)

export default component.exports